import * as types from '../../action/actionTypes';
import initialState from '../initialState';

export default function ManageDashboardsReducer(state = initialState.Dashboards, action) {
    switch (action.type) {
        case types.GET_DASHBOARDS_LIST: return {
           ...state, ManageDashboardList: action.getResponse,
        };
        default : return state; 
    }   
}